import { useEffect, useState } from 'react'

import classNames from 'classnames'
import Header from 'components/Organisms/Header'
import { FaArrowUp } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

const ExternalLayout = ({ children }: any) => {
  const navigate = useNavigate()
  const [scrolled, setScrolled] = useState(false)
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  const headerClassName = classNames(
    'bg-white',
    'fixed',
    'w-full',
    'top-0',
    'left-0',
    'mx-auto',
    'z-50',
    'transition-all',
    'duration-500',
    { 'shadow-md': scrolled },
  )
  const upButtonClassName = classNames(
    'fixed',
    'bottom-16',
    'right-16',
    'z-50',
    'transition-all',
    'duration-300',
    'ease-in-out',
    'transform',
    {
      'scale-0': !scrolled,
      'scale-100': scrolled,
    },
  )
  const handleOnClick = (sectionId: any) => {
    navigate(`/#${sectionId}`)
  }
  return (
    <div className="w-screen h-full">
      <div className={headerClassName}>
        <Header
          logo="logo_10years.png"
          onClick={handleOnClick}
          hideOptions
          cicloBono
          onlySpanish
        />
      </div>
      <div className="mt-36">{children}</div>
      <div className={upButtonClassName}>
        <button
          className="rounded-full p-3 bg-blue-800 text-2xl shadow-md transition-all duration-500"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <FaArrowUp className="scrollTop text-white" />
        </button>
      </div>
    </div>
  )
}

export default ExternalLayout
